/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <b-row>
    <b-col sm="12">
      <!-- firstname -->
      <b-form-group id="groupFirstName" :label-for="name + '-firstname'" :key="name + '-firstname'">
        <base-input
          :placeholder="$t('address.FirstName') + ' *'"
          :name="name + '-firstname'"
          autocomplete="firstname"
          v-validate="'required'"
          v-model="address.firstname"
          type="text"
          :focus="true"
          :validations="[
            {
              condition: errors.has(name + '-firstname'),
              text: errors.first(name + '-firstname')
            }
          ]"
        >
        </base-input>
      </b-form-group>
    </b-col>

    <b-col sm="12">
      <!-- lastname -->
      <b-form-group id="groupLastName" :label-for="name + '-lastname'" :key="name + '-lastname'">
        <base-input
          :placeholder="$t('address.LastName') + ' *'"
          :name="name + '-lastname'"
          autocomplete="lastname"
          v-validate="'required'"
          v-model="address.lastname"
          type="text"
          :validations="[
            {
              condition: errors.has(name + '-lastname'),
              text: errors.first(name + '-lastname')
            }
          ]"
        >
        </base-input>
      </b-form-group>
    </b-col>

    <b-col sm="12">
      <div class="row">
        <b-col sm="8">
          <!-- streetAddress -->
          <b-form-group :id="_uid + '-groupStreetAddress'" :label-for="name + '-streetAddress'" :key="_uid + '-groupStreetAddress'">
            <base-autocomplete
              :name="name + '-streetAddress'"
              v-model="streetAddress"
              v-validate="'required'"
              :placeholder="$t('address.StreetAddress') + ' *'"
              labelClass="absolute-label"
              @place_changed="setPlace"
              :validations="[
                {
                  condition: errors.has(name + '-streetAddress'),
                  text: errors.first(name + '-streetAddress')
                }
              ]"
            />
          </b-form-group>
        </b-col>
        <!-- StreetAddress2 -->
        <b-col sm="4">
          <b-form-group :id="_uid + '-groupStreetAddress2'" :label-for="name + 'streetAddress2'" :key="_uid + '-groupStreetAddress2'">
            <base-input
              :placeholder="$t('address.StreetAddress2')"
              :name="name + '-streetAddress2'"
              autocomplete="StreetAddress2"
              v-model="streetAddress2"
              type="text"
              :validations="[
                {
                  condition: errors.has(name + '-streetAddress2'),
                  text: errors.first(name + '-streetAddress2')
                }
              ]"
            >
            </base-input>
          </b-form-group>
        </b-col>
      </div>
    </b-col>

    <b-col sm="12">
      <b-row>
        <b-col sm="8">
          <!-- City -->
          <b-form-group :id="_uid + '-groupCity'" :label-for="name + '-city'" :key="_uid + '-groupCity'">
            <base-input
              :placeholder="$t('address.City') + ' *'"
              :name="name + '-city'"
              autocomplete="city"
              v-validate="'required'"
              v-model="address.city"
              type="text"
              :validations="[
                {
                  condition: errors.has(name + '-city'),
                  text: errors.first(name + '-city')
                }
              ]"
            >
            </base-input>
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <!-- Province -->
          <b-form-group :id="_uid + '-groupState'" :label-for="name + '-state'" :key="_uid + '-groupState'">
            <select-province
              :placeholder="$t('address.State') + ' *'"
              :name="name + '-state'"
              selectClass="select-shadowed"
              autocomplete="state"
              v-model="state"
              :country-id="address.country_id"
              v-validate="'required'"
              :validations="[
                {
                  condition: errors.has(name + '-state'),
                  text: errors.first(name + '-state')
                }
              ]"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-col>

    <b-col sm="6">
      <!-- Country -->
      <b-form-group :id="_uid + '-groupCountry'" :label-for="name + '-country'" :key="_uid + '-groupCountry'">
        <base-select
          :placeholder="$t('address.Country') + ' *'"
          selectClass="select-shadowed"
          :name="name + '-country'"
          v-model="address.country_id"
          :options="countryAvailable"
          :reduce="opt => opt.id"
          :readonly="disableCountry"
          @input="changeCountry"
          :clearable="false"
          :searchable="false"
          :validations="[
            {
              condition: errors.has(name + '-country'),
              text: errors.first(name + '-country')
            }
          ]"
          >
        </base-select>
      </b-form-group>
    </b-col>

    <!-- POSTCODE | TELEPHONE -->
    <b-col sm="12">
      <div class="row">
        <b-col sm="4">
          <!-- postcode -->
          <b-form-group :id="_uid + '-groupZipCode'" :label-for="name + '-postcode'" :key="_uid + '-groupZipCode'">
            <base-input
              :placeholder="$t('address.ZipCode') + ' *'"
              :name="name + '-postcode'"
              autocomplete="postcode"
              v-validate="'required'"
              v-model="address.postcode"
              type="text"
              :validations="[
                {
                  condition: errors.has(name + '-postcode'),
                  text: errors.first(name + '-postcode')
                }
              ]"
            />
          </b-form-group>
        </b-col>
        <b-col sm="8">
          <!-- telephone -->
          <b-form-group id="groupPhoneNumber" :label-for="name + '-telephone'">
            <base-input
              :placeholder="$t('address.PhoneNumber') + ' *'"
              :name="name + '-telephone'"
              autocomplete="telephone"
              v-validate="'required|phoneNumber'"
              v-model="address.telephone"
              type="tel"
              :validations="[
                {
                  condition: errors.has(name + '-telephone'),
                  text: errors.first(name + '-telephone')
                }
              ]"
            >
            </base-input>
          </b-form-group>
        </b-col>
      </div>
    </b-col>
    <!-- POSTCODE | TELEPHONE -->

  <!-- </b-collapse> -->
  </b-row>
</template>

<script>
import { EventBus } from '@/helpers'
import { getCountry } from '@/store/modules/checkout/defaultValues'
import find from 'lodash/find'
import BaseAutocomplete from 'theme/components/Form/BaseAutocomplete.vue'
import BaseInput from 'theme/components/Form/BaseInput'
import BaseSelect from 'theme/components/Form/BaseSelect'
import SelectProvince from 'theme/components/SelectProvince.vue'

export default {
  name: 'AddressAutocomplete',
  inject: ['$validator'],
  props: {
    name: {
      type: String,
      default () {
        return ''
      }
    },
    address: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      countryAvailable: [],
      searchValue: '',
      showCollapse: true,
      fieldsToValidate: [this.name + '-streetAddress', this.name + '-postcode', this.name + '-city', this.name + '-state', this.name + '-country']
    }
  },
  computed: {
    disableCountry () {
      return this.countryAvailable.length === 1 && this.address.country_id === this.countryAvailable[0].id
    },
    isValidForm () {
      for (let i in this.fieldsToValidate) {
        if (this.errors.has(this.fieldsToValidate[i])) {
          return false
        }
      }
      return true
    },
    addressFields () {
      /* const self = this
      let filteredFields = {}
      this.fieldsToValidate.forEach(key => {
        filteredFields[key] = self.fields[key]
      })
      return filteredFields */
      return {}
    },
    streetAddress: {
      get () {
        return this.address.street && this.address.street.length ? this.address.street[0] : ''
      },
      set (newValue) {
        let newStreet = [newValue]
        if (this.address.street.length > 1) {
          newStreet.push(this.address.street.slice(1, this.address.street.length).join(''))
        }
        this.address.street = newStreet
      }
    },
    streetAddress2: {
      get () {
        return this.address.street && this.address.street.length > 1 ? this.address.street.slice(1, this.address.street.length).join(' ') : ''
        // return this.address.street && this.address.street.length > 1 ? this.address.street[1] : ''
      },
      set (newValue) {
        let newStreet = ['']
        if (this.address.street && this.address.street.length) {
          newStreet[0] = this.address.street[0]
        }
        newStreet[1] = newValue
        this.address.street = newStreet
      }
    },
    state: {
      get () {
        return this.address.region && this.address.region.region_code ? this.address.region.region_code : ''
      },
      set (newValue) {
        this.address.region = {
          region: newValue.label || newValue,
          region_code: newValue.code || newValue,
          region_id: 0
        }
      }
    }
  },
  methods: {
    changeCountry ($event) {
      this.state = ''
      this.$emit('changeCountry', $event)
    },
    setAvaibleCountries (countries) {
      return countries.map(item => {
        return {
          id: item.id,
          label: item.full_name_locale,
          label_en: item.full_name_english,
          code: item.two_letter_abbreviation
        }
      })
    },
    validatorForceReset (boolval) {
      if (boolval) {
        this.$nextTick(() => {
          this.$validator.reset()
        })
      }
    },
    async setPlace (place) {
      if (!place) {
        return ''
      }
      const self = this
      const addressComponentsMap = {}
      place.address_components.forEach(element => {
        element.types.forEach(type => {
          addressComponentsMap[type] = element
        })
      })
      this.streetAddress =
      this.streetAddress2 =
      this.address.postcode =
      this.address.city =
      this.state =
      this.address.country_id = ''
      // set Address
      if (addressComponentsMap.route) {
        this.streetAddress = addressComponentsMap.route.short_name
      }
      if (addressComponentsMap.street_number) {
        this.streetAddress += ', ' + addressComponentsMap.street_number.short_name
      }
      if (addressComponentsMap.postal_code) {
        this.address.postcode = addressComponentsMap.postal_code.short_name
      }
      if (addressComponentsMap.administrative_area_level_3 || addressComponentsMap.locality) {
        this.address.city = addressComponentsMap.administrative_area_level_3 ? addressComponentsMap.administrative_area_level_3.short_name : addressComponentsMap.locality.long_name
      }
      if (addressComponentsMap.administrative_area_level_2) {
        this.state = addressComponentsMap.administrative_area_level_2.short_name
      }
      if (addressComponentsMap.country && find(this.countryAvailable, { id: addressComponentsMap.country.short_name })) {
        this.address.country_id = addressComponentsMap.country.short_name
      }
      if (this.state) {
        if (!this.isAvailableRegions(this.state)) {
          this.state = ''
        }
      }
      await this.$nextTick()
      this.fieldsToValidate.forEach((strField) => {
        self.validField(strField)
      })
    },
    isAvailableRegions (stateCode) {
      if (this.$store.state.checkout.countries.length > 0) {
        const countryFound = find(this.$store.state.checkout.countries, { 'id': this.address.country_id })
        return countryFound ? Boolean(find(countryFound.available_regions, { code: stateCode })) : false
      }
      return false
    },
    validField (strField) {
      this.$validator.validate(strField).then((result) => {
        if (!result) {
          console.log('not valid ', strField)
        }
        return result
      })
    },
    changeInputManualMode () {
      if (this.streetAddress && this.address.postcode && this.address.city && this.state && this.address.country_id) {
        const strCompose = `${this.streetAddress}, ${this.address.postcode} ${this.address.city} ${this.state}, ${this.address.country_id}`
        if (this.$refs.autocompleteController) {
          this.$refs.autocompleteController.$el.value = strCompose
        }
      }
    }
  },
  mounted () {
    EventBus.$on('address-autocomplete::force-validate-reset', this.validatorForceReset)
    return this.$store.dispatch('checkout/loadCountries').then((countries) => {
      // preset country
      this.countryAvailable = this.setAvaibleCountries(countries)
      const currentCountry = getCountry(this.address.country_id, this.countryAvailable, this.$store)
      if (currentCountry !== this.address.country_id) {
        this.address.country_id = currentCountry
      }
    })
  },
  destroyed () {
    EventBus.$off('address-autocomplete::force-validate-reset', this.validatorForceReset)
  },
  components: {
    BaseAutocomplete,
    BaseInput,
    BaseSelect,
    SelectProvince
  }
}
</script>
